import { Comments } from "@/shared/components/comments";
import { RobotoLink } from "@/shared/components/RobotoLink";
import { commentEntityRoute } from "@/shared/domain/comments";
import type { UIComment } from "@/shared/domain/comments/hooks/useUIComment";
import { EntityIcon } from "@/shared/foundation/icons";
import { Goto } from "@/shared/navigation/Goto";

import styles from "./CommentHeader.module.css";

interface CommentHeaderProps {
  /** Comment to display */
  comment: UIComment;
}

export function CommentHeader({ comment }: CommentHeaderProps) {
  const entityLink = commentEntityRoute(comment);

  // Fall back to the user ID if we don't have a display name
  const displayName = comment.creatorDisplayName ?? comment.created_by;

  return (
    <div className={styles.userInfo}>
      {comment.isSystemUser ? (
        <span className={styles.userName}>{displayName}</span>
      ) : (
        <RobotoLink
          to={Goto.createUserRoute(comment.created_by)}
          className={styles.userName}
        >
          {displayName}
        </RobotoLink>
      )}
      <span className={styles.separator}>•</span>
      <Comments.Time
        timestamp={comment.modified}
        className={styles.timestamp}
      />
      <span className={styles.separator}>•</span>
      <RobotoLink to={entityLink} className={styles.entityInfo}>
        <EntityIcon
          type={comment.entity_type}
          size={16}
          className={styles.entityIcon}
        />
        <span className={styles.entityId}>{comment.entity_id}</span>
      </RobotoLink>
    </div>
  );
}
